import {AssetPropertyDto} from '../../../common/shared/api/nicolas/vo/AssetPropertyDto.interface';
import {isNilEmpty} from '../../../common/shared/utils/isNilEmpty';

export const getUseBookCardCover = (asset_property?: AssetPropertyDto) => {
  const {card_set, card_img, card_cover} = asset_property ?? {};

  // card_cover 를 사용하는지에 대한 여부를 판단.
  const useBookCardCover =
    isNilEmpty(card_set?.background_img) &&
    isNilEmpty(card_img) &&
    !isNilEmpty(card_cover);

  // new/old 카드 에셋이 없고 표지 가공(cover_restricted=true) 허용하지 않을 경우 카드뷰(책) 형태로 제공
  const showBookCardView =
    useBookCardCover && card_cover.cover_restricted === true;

  return {useBookCardCover, showBookCardView};
};
